import HeaderQuote from './HeaderQuote'


export default HeaderQuote
